export const API_KEY = process.env.REACT_APP_OPENWEATHERMAP_API_KEY || 'YOUR_OPENWEATHERMAP_API_KEY';
export const BASE_URL = 'https://api.openweathermap.org/data/2.5'; 